var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#048657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4805 9.32074L2.57737 8.07143H6.48L8.87794 11.1303L15.1526 2.43799C15.5378 2.78561 15.8882 3.16993 16.1989 3.58549C16.5227 4.0162 16.8044 4.47692 17.0404 4.96136L9.33694 15.6168C9.19125 15.7698 9.03825 15.8463 8.87794 15.8463C8.71706 15.8463 8.55562 15.7698 8.39306 15.6168L3.52125 9.32018L1.4805 9.32074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtc);
export default __webpack_public_path__ + "static/media/vtc.7a2ce6b552261a715d4a78929b76462e.svg";
export { ForwardRef as ReactComponent };